import {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useWhatsappNumbers = () => {
  const {
    api,
    userID,
    whatsappNumbers,
    setWhatsappNumbers,
    whatsappFetched,
    setWhatsappFetched,
  } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  const fetchWhatsappNumbers = useCallback(async () => {
    if (!userID || whatsappFetched) return;

    try {
      setLoading(true);

      const data = await postRequest(
        "/Whatsapp/v1.0/getWhatsappNumbers",
        {
          userid: userID,
        }
      );

      if (data?.responseCode === "00") {
        setWhatsappNumbers(data?.response || []);
        setWhatsappFetched(true);
      } else {
        setWhatsappNumbers([]);
      }

      return data;
    } catch (err) {
      console.error(
        "Whatsapp Numbers Error:",
        err?.response?.data || err
      );

      setWhatsappNumbers([]);

      return null;
    } finally {
      setLoading(false);
    }
  }, [
    userID,
    whatsappFetched,
    postRequest,
    setWhatsappNumbers,
    setWhatsappFetched,
  ]);

  useEffect(() => {
    if (!userID) return;

    fetchWhatsappNumbers();
  }, [userID, fetchWhatsappNumbers]);

  return {
    whatsappNumbers,
    loading,
    fetchWhatsappNumbers,
  };
};

export default useWhatsappNumbers;